module.exports = __webpack_public_path__ + "static/img/hero_shape_3.c57d5a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_shape_3.png
// module id = o7E2
// module chunks = 0